import { FavoriteCuisinesService } from "@/clients/services/FavoriteCuisinesService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useQuery } from "@tanstack/react-query";

export const useGetFavoriteCuisines = () => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: [QueryKeys.FAVORITE_CUISINES],
    queryFn: async () => {
      const user = guardGetUserFromLocalStorage();
      const { data } =
        await FavoriteCuisinesService.getFavoriteCuisinesApiV1FavoriteCuisinesGet(
          user.id,
        );
      if (error) {
        throw new Error(error.message);
      }
      return data;
    },
  });
  return {
    favoriteCuisines: data,
    isLoading: isPending,
    isError,
    error,
  };
};
